import { Pagination } from "@mantine/core";
import { useCancelledOffers } from "hooks/usePublishedOffer";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { NetworkStatus } from "@apollo/client";
import { usePage } from "hooks/usePage";
import { useRealtimeConnection } from "hooks/useRealTimeConnection";
import config from "config";
import PageHeader from "../../components/layout/page-header";
import PageWrapper from "../../components/layout/page-wrapper";
import OfferCardGrid from "../AllBusiness/components/PublishedOfferCardGrid";

const CancelledOffersPage: FC = () => {
    const { t } = useTranslation();
    usePage("Kava | Cancelled Offers");

    const [perPage] = useState(10);
    const [page, setPage] = useState(1);
    const [searchValue, setSearchValue] = useState("");

    const {
        cancelledOffers,
        loading,
        refresh,
        error,
        networkStatus,
    } = useCancelledOffers({
        published_by: "PLACEIT",
    });

    useRealtimeConnection({
      subscriptions: [
        {
          channel: config.realtime.channels.KAVA_NOTIFICATION,
          events: [config.realtime.events.BROKER_THREAD_NOTIFICATION],
        },
        {
          channel: config.realtime.channels.KEK_CHANNEL,
          events: [
            config.realtime.events.BROKER_THREAD_NOTIFICATION
          ],
          pusherInstanceId: "kek",
        },
      ],
      callback: () => refresh(),
    });

    const filteredOffers = searchValue.trim()
        ? (cancelledOffers || []).filter((offer: any) => {
              const term = searchValue.toLowerCase();
              return (
                  offer?.offer_detail?.insured_by?.toLowerCase().includes(term) ||
                  offer?.offer_detail?.policy_number?.toLowerCase().includes(term) ||
                  offer?.insurer?.insurer_company_name?.toLowerCase().includes(term) ||
                  offer?.offer_id?.toLowerCase().includes(term) ||
                  offer?.offer_cancel_reason?.toLowerCase().includes(term)
              );
          })
        : cancelledOffers || [];

    const totalOffers = filteredOffers.length;
    const from = totalOffers === 0 ? 0 : (page - 1) * perPage + 1;
    const to = Math.min(page * perPage, totalOffers);
    const lastPage = Math.ceil(totalOffers / perPage);

    return (
        <PageWrapper>
            <PageHeader title={t("pages.cancelled_offers.title", { defaultValue: "Cancelled Offers" })} />

            <section className="mt-8" aria-labelledby="cancelled-offers-heading">
                <OfferCardGrid
                    offers={filteredOffers as any[]}
                    searchValue={searchValue}
                    search={(value) => { setSearchValue(value); setPage(1); }}
                    selected={[]}
                    loading={[NetworkStatus.loading].includes(networkStatus)}
                    error={error}
                    refresh={refresh}
                    renderAction={null}
                    filterStatus="CANCELLED"
                    onFilterStatusChange={() => {}}
                    showFilterControls={false}
                    subFilterStatus="All"
                    summaryCount={undefined}
                    summaryLoading={false}
                />
            </section>

            <section className="p-3 flex justify-between items-center mt-6">
                <span>
                    {t("pages.all_business.pagination.showing", {
                        from,
                        to,
                        total: totalOffers,
                    })}
                </span>
                {lastPage > 1 && (
                    <Pagination
                        total={lastPage}
                        page={page}
                        onChange={(p) => setPage(p)}
                    />
                )}
            </section>
        </PageWrapper>
    );
};

export default CancelledOffersPage;
